import * as React from 'react'
import * as styles from './Timer.module.scss'

interface TimerProps {
    onEnd: () => void
    numSeconds: number
}

export class Timer extends React.Component<TimerProps> {

    render() {
        return (<svg className={styles.timer} viewBox="0 0 200 200">
            <g transform="
                  rotate(270 100 100)
                ">
                <circle className={styles.circle}
                    stroke="black" strokeWidth="100" r="50" cx={100} cy={100} fill="none" strokeDasharray="0 314">
                    <animate
                        ref={(elem) => { if (elem) elem.addEventListener("endEvent", this.props.onEnd) }}
                        attributeName="stroke-dasharray"
                        values="
                          0 314;
                          78.75 236.25;
                          157.5 157.5;
                          236.25 78.75;
                          314 0;
                          " dur={this.props.numSeconds} repeatCount={0} />
                </circle>
            </g>
        </svg>)
    }
}